// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3_aYc","head":"Table_head__3c71t","col":"Table_col__2XLU_"};